<template>
	<div >
		<div class="content">
			<div class="logo"></div>
			<div class="input-wrap" :class='borderFlag?"have-border":""'>
				<label for="phone" class="title">账号</label>
				<cube-input v-model="info.account" placeholder="请输入您的账号" type="text" id="phone" @input="onMobileInput"></cube-input>
			</div>
		
			<div class="identify_no_wrap">
				<div class="input-wrap" :class='borderMark?"have-border":""'>
					<label for="identify-no" class="title">密码</label>
					<cube-input v-model="info.password" placeholder="请输入您的密码" type="password" id="identify-no" @input="onCodeInput" @focus="onFocus" @blur="onBlur"></cube-input>
				</div>
			</div>
			
			<div :class="{loginBtn: true, canLogin:true}" @click="onLoginClick">登录</div>
		</div>
	</div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'
import {AccountLogin ,getCommunal} from '@/api/common'
import utils from '@/assets/jslibs/utils'
import { mapMutations } from 'vuex'

export default {
    name: 'login',
    data() {
        return {
            info: {
                account: '',
                password: '',
            },
            maxTel:11,
			canGetCode: false,
            isCodeEmpty: false,
			borderFlag:false,
			borderMark:false
        }
    },
    
    created(){
		sessionStorage.removeItem("roleType");
        sessionStorage.removeItem("peg");         //用户重新登录的时候，清除用户端展示模块的标示 登录后默认展示首页
        sessionStorage.removeItem("stamp");       //用户重新登录的时候，清除业务员端展示模块的标示 登录后默认展示首页
        sessionStorage.removeItem("mark");
        sessionStorage.removeItem("sign");
        
        //清除用户下单时的信息回填，用户填写信息只在用户下单时存在
        sessionStorage.removeItem("params");
        sessionStorage.removeItem("newOrder");
        sessionStorage.removeItem("placeOrderId"); 
		sessionStorage.removeItem("roleName");
        this.getCommunal();
    },
    
    mounted(){
        document.title = "登录"
    },
    
    methods: {
        ...mapMutations(['update_expiry_time']),
        onMobileInput() {
			if(this.info.account){
				this.canGetCode = true;
				if (this.info.account.length >= 2) {
					this.borderFlag = true;
					this.borderMark = false;
				} else {
					this.borderFlag = false;
				}
			}else{
				this.canGetCode = false;
			}
			
		},
    
		navigateTo(path) {
			this.$router.push(path)
		},
		
		onCodeInput() {
			if (this.info.password) {
				this.isCodeEmpty = true;
			} else {
				this.isCodeEmpty = false;
			}
		},
		
		onFocus(){
			this.borderFlag = false;
			this.borderMark = true;
		},
		
		onBlur(){
			this.borderMark = false;
		},
    
		async onLoginClick() {
			const { account,password} = this.info;
			//如果账号 和密码不能为空为空退出
			if (!this.isCodeEmpty){
				window.toast('账号不能为空', 'txt');
				return
			}
			if (!this.canGetCode) {
				window.toast('密码不能为空', 'txt');
				return
			}
			
			if (!(/^[0-9a-zA-Z]+$/.test(password))) {
				window.toast('密码只能为英文和数字', 'txt')
				return
			} 
			const { data , status } = await AccountLogin(this.info);
			if (status !== 200) return
			utils.setCookie('X-Access-Token', data.user_access_token.token, 7)
			this.update_expiry_time(data.user_access_token.expiry_time)
			if(data.user_info.type=="2"){//业务员
				sessionStorage.setItem("roleName","sale");
				this.$router.push('./index-sale')
			}else if(data.user_info.type=="3"){//管理员
				sessionStorage.setItem("roleName","admin");
				this.$router.push('./myorder-admin')
			}
			
		},
		
		//获取七牛信息
		async getCommunal() {
			const { data, status } = await getCommunal();
			if (status !== 200) return 
		    this.$store.commit("setImgUrl",data.BucketDomain);
		    sessionStorage.setItem("imgUrl",data.BucketDomain);
		},
	},
	components:{
		CommonHeader
	}
}
</script>

<style lang='less' scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';
.content {
	.f-s(16);
	margin: 0 0.49333333rem 0 0.52rem;
	.header {
		.f-s(24);
		font-family:PingFangSC-Medium;
		font-weight:500;
		color:rgba(20,20,20,1);
	}
	
	.logo{
		width:250px;
		height:100px;
		background: url(../assets/images/logo.png) no-repeat center center;
		background-size: 250px;
		margin: 0 auto;
		margin-top: 17px;
	}
	
	.have-border{
		border-bottom: 1px solid #4A90E2
	}
	
	.input-wrap {
		.m-t(10);
		.title {
			.f-s(15);
			.m-t(16);
			.m-b(10);
			display: block;
			font-family:PingFangSC-Regular;
			font-weight:500;
			color:rgba(20,20,20,1);
			font-size:0.42666667rem;
		}
	
		/deep/.cube-input {
			.w(335);
			/deep/.cube-input-field{
				padding: 0.266667rem 0;
				font-size: 0.3733333rem;
			}
		}
	
		/deep/.cube-input::after {
			border: 0;
			border-bottom: 1px solid #eee;
		}
	}
  
	.identify_no_wrap {
		display: flex;
		align-items: flex-end;
		/deep/.cube-input {
			/* .w(231); */
		}
		
		.get_code_btn {
			.w(100);
			.h(40);
			.l-h(40);
			.f-s(13);
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(255,255,255,1);
			text-align: center;
			background:rgba(207,207,207,1);
			border-radius:2px;
		}
		
		.can_get_code {
			background:rgba(74,144,226,1);
		}
		.cannot_get_code {
			background:rgba(207,207,207,1);
		}
	}
	
	.xieYi{
		position: absolute;
		bottom: 0.4266667rem;
		left: 2.4266667rem;
		.agree{
			color: #666666;
			font-size: 0.32rem;
		}
		.agreeText{
			color: #141414;
			font-size: 0.32rem;
		}
	}
	
	.loginBtn {
		.h(46);
		.l-h(46);
		.w(337.5);
		.m-t(25);
		.f-s(16);
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(255,255,255,1);
		text-align: center;
		background:rgba(193,193,193,1);
		border-radius:2px;
	}
	
	.canLogin {
		background:rgba(74,144,226,1);
	}
}
</style>
